import bhk_1 from '../assets/images/Sky_Crest_8/FloorPlan/1Bhk.jpg'
import bhk_2 from '../assets/images/Sky_Crest_8/FloorPlan/2Bhk(01).jpg'
import bhk_3 from '../assets/images/Sky_Crest_8/FloorPlan/3Bhk.jpg'
import bhk_4 from '../assets/images/Sky_Crest_8/FloorPlan/4Bhk.jpg'
import bhk_5 from '../assets/images/Sky_Crest_8/FloorPlan/5Bhk.jpg'
import bhk_2_02 from '../assets/images/Sky_Crest_8/FloorPlan/2Bhk(02).jpg'

import backIcon from "../assets/images/back_icon.png";

import '../assets/css/floorplan.css';
import { useState } from 'react';
import { Modal } from 'react-bootstrap'

const FloorPlanSkyCrest8 = () => {
    const [isZoomed, setIsZoomed] = useState(false);

    const [activeFilterIndex, setActiveFilterIndex] = useState(0);
    const [imageSrc, setImageSrc] = useState(bhk_1);


    const [showPlan, setShowPlan] = useState(false);
    const [isTypicalPlan, setIsTypicalPlan] = useState(false)

    const [openFlat, setOpenFlat] = useState("");
    const [showIframe, setShowIframe] = useState(false);

    const changeFloorPlan = (floorPlan, index) => {
        setActiveFilterIndex(index);
        setImageSrc(floorPlan);
    }

    return (
        <div className="courtyard elysium_tower floorplan_container">
            <div className="w-100 d-flex justify-content-sm-between h-100">
                <div className="left_side_container grey-bg">
                    <img alt="floor_plan_image" src={imageSrc} style={{ maxWidth: "100%" }} className={`zoomable-image ${isZoomed ? "zoomed" : ""}`} onClick={() => setIsZoomed(!isZoomed)} />
                    {
                        <div className='view-web-vr center'><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); }}>Explore WebVR</button> </div>
                    }
                </div>
                <div className="right_side_container">
                    <div className='floor_plan_button-conainer'>
                        <button className="floor_plan_lable">Floor Plans</button>
                        <button onClick={() => { changeFloorPlan(bhk_1, 0); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Sky_Crest/sky_crest-1bhk/index.html'); }} className={`${activeFilterIndex === 0 ? 'active' : ''} `}>1 BHK</button>
                        <button onClick={() => { changeFloorPlan(bhk_2, 1); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Sky_Crest/sky_crest-2bhk/index.html") }} className={`${activeFilterIndex === 1 ? 'active' : ''} `}>2 BHK </button>
                        <button onClick={() => { changeFloorPlan(bhk_2_02, 4); setOpenFlat('https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Sky_Crest/sky_crest-2bhk-03/index.html') }} className={`${activeFilterIndex === 4 ? 'active' : ''} `}>2 BHK 03 </button>
                        <button onClick={() => { changeFloorPlan(bhk_3, 2); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Sky_Crest/sky_crest-3bhk/index.html"); }} className={`${activeFilterIndex === 2 ? 'active' : ''} `}>3 BHK</button>
                        <button onClick={() => { changeFloorPlan(bhk_4, 6); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Sky_Crest/sky_crest_4bhk/index.html") }} className={`${activeFilterIndex === 6 ? 'active' : ''} `}>4 BHK</button>
                        <button onClick={() => { changeFloorPlan(bhk_5, 3); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Sky_Crest/sky_crest_5bhk/index.html") }} className={`${activeFilterIndex === 3 ? 'active' : ''} `}>5 BHK</button>
                    </div>

                </div>
            </div>

            <Modal
                centered
                show={showPlan}
                onHide={() => setShowPlan(false)}
                aria-labelledby="example-custom-modal-styling-title"
                className="inventory_floor_plan_dialog"
            >
                <Modal.Body>
                    <button className="back_btn" onClick={() => { if (showIframe) { setShowIframe(false); } else { setShowPlan(false) } }}>
                        <img src={backIcon} alt="back icon" className="backIcon" />
                    </button>
                    <iframe src={openFlat} height="100%" width="100%" className="flats_iframe flats_iframe_elysium" />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default FloorPlanSkyCrest8;